import { useQueryUserId } from "./query";
import { rpc, rpcForSpace, selectedSpaceId } from "./rpc";
import { useBoundSpaceId } from "./space-rpc";

export function useShoppingScope() {
  const user = useQueryUserId();
  const space = useBoundSpaceId() ?? selectedSpaceId();
  return { user, space, rpc: space ? rpcForSpace(space) : rpc };
}
